import $ from 'jquery';

document.addEventListener('facetwp-loaded', () => {
	$('.facetwp-template').foundation();
});